<template>
  <v-container>

    <v-row>
      <v-col cols="4">
        <v-row align="center" >
          <v-col cols="5">
            <v-text-field hide-details rows="2" label="Total Interest Amount"
            v-model.number="total.interestAmount"
          class="input-text-size mt-1 "></v-text-field>
          </v-col>
          <v-col cols="7">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" small @click="breakdownInterest">
                  Breakdown Total Interest
                </v-btn>
              </template>
              <span>Breakdown Total Interest</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row align="center" >
          <v-col cols="5">
            <v-text-field hide-details rows="2" label="Protest Interest Refund"
            v-model.number="total.interestRefundAmount"
          class="input-text-size mt-1 mr-4"></v-text-field>
          <v-text-field hide-details rows="2" label="Protest Interest Release"
          v-model.number="total.interestReleaseAmount"
          class="input-text-size mt-1 mr-4"></v-text-field>
          </v-col>
          <v-col cols="7">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="primary" small @click="applyInterest">
                  Apply Interest
                </v-btn>
              </template>
              <span>Apply Interest</span>
            </v-tooltip>
          </v-col>
        </v-row>

      </v-col>
      <v-col cols="4" >
        <div class=" btns mt-2 ">
                        <ClarionDateControl
                          class="input-text-size"
                          :isRequired="false"
                          :isIsoDate="false"
                          v-model="businessDate"
                          :isToggle="false"
                          label="Business Date"
                        />
                     </div>
        <div class=" btns mt-2 "><v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary" @click="handleReport"  >
                Print Protest Summary
              </v-btn>
            </template>
            <span> Print Protest Summary</span>
          </v-tooltip></div>
          <div class=" btns mt-2 "><v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary"  @click="handleMakePayment('refund')">
                Create Tax Refunds
              </v-btn>
            </template>
            <span>Create Tax Refunds</span>
          </v-tooltip></div>
          <div class=" btns mt-2 "><v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary" @click="handleMakePayment('protest')">
                Create Tax Credits <br/>For Release Protest
              </v-btn>
            </template>
            <span> Create Tax Credits <br/>For Release Protest</span>
          </v-tooltip></div>
          <div class=" btns mt-2 "><v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary" @click="createApportRecords">
                Create Apportionment Records <br/>For Release Of Interest
              </v-btn>
            </template>
            <span>  Create Apportionment Records  <br/>For Release Of Interest</span>
          </v-tooltip></div>
      </v-col>
      <v-col cols="4" >

        <div class=" btns mt-2 "><v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary"
              @click="printApportionmentReport('taxes')">
                Print Apportionment Report <br/>For Release Of Taxes
              </v-btn>
            </template>
            <span> Print Apportionment Report <br/>For Release Of Taxes</span>
          </v-tooltip></div>
          <div class=" btns mt-2 "><v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary"
              @click="printApportionmentReport('interest')">
                Print Apportionment Report <br/>For Release Of Interest
              </v-btn>
            </template>
            <span> Print Apportionment Report <br/>For Release Of Interest</span>
          </v-tooltip></div>
          <div class=" btns mt-2 "><v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary"
              @click="printApportionmentReport('combine')">
                Print
                  Combined Report of <br/>Taxes + Interest Released
              </v-btn>
            </template>
            <span> Print
                  Combined Report of Taxes + Interest Released</span>
          </v-tooltip></div>

      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  mapMutations, mapGetters, mapActions, mapState,
} from 'vuex';
import '../../../assets/style.css';
import { amountFormat, amountToNumber } from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';
import { makeCriteriaStateNullIfEmptyString } from '../common-utils/CommonTaxFunctionalities';
import { toFiscalYear, toIsoDate, toShortDate } from '../../../util/shared/tmc-global';
import { penaltyCalculation } from '../common-utils/tax-common.util';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { getWorkstationNumber } from '../../../util/workstation-util';

const { backendRest } = clients.direct;

export default {
  name: 'ProtestedTaxFooter',

  data() {
    return {
      baseCrudKey: 'protestedTax',
      crudKeyForPayment: 'paymentDialog',
      total: {
        interestAmount: 0,
        interestRefundAmount: 0,
        interestReleaseAmount: 0,
        protestedTax: [],

      },
      totalAmtUnderProtest: 0,
      businessDate: toIsoDate(new Date()),
      fromDate: toShortDate(this.todaysDate),
      wkstNumber: getWorkstationNumber(),

    };
  },
  components: {
    ClarionDateControl,
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'items', 'item']),
    ...mapGetters(['todaysDate']),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,

      StoreSelItems: (state) => state.tax.taxProtests.selectedItems,

    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    protestTaxesGetter: {
      get() {
        return this.items(this.baseCrudKey);
      },
      set(value) {
        this.setItems([this.baseCrudKey, value]);
      },
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },

  },

  methods: {

    ...mapMutations('base/crud', [
      'setCriteria', 'setItems', 'setItem', 'setIsVisible', 'setIndex',
    ]),
    ...mapMutations('tax/taxProtests', ['setSelectedItems']),
    ...mapActions(['reAuth', 'custumColrFlashMsg']),
    ...mapActions('tax/taxProtests', ['loadTaxProtests', 'upsertBulkTaxProtest']),
    ...mapActions('tax/taxPayment', [
      'generateMultipleReceipt',
    ]),
    ...mapActions('apportionment/apportionmentTaxes', [
      'upsertTaxApportionmentInBulk',
    ]),
    ...mapActions(['flashSuccess']),

    async breakdownInterest() {
      const interestAmount = amountToNumber(this.total.interestAmount);
      if (interestAmount === 0) {
        this.custumColrFlashMsg({ msg: 'Please enter a valid interest amount' });
        return;
      }

      const protestTaxes = this.selectedItems.filter((el) => typeof el === 'object');
      if (protestTaxes.length === 0) {
        this.custumColrFlashMsg({ msg: 'Please select records to breakdown interest' });
        return;
      }

      this.totalAmtUnderProtest = 0;
      let tRefundToTaxPayer = 0;
      let tReleaseToApportion = 0;

      for (let i = 0; i < protestTaxes.length; i += 1) {
        const item = protestTaxes[i];
        this.totalAmtUnderProtest += amountToNumber(item.amountPaidUnderProtest);
        tRefundToTaxPayer += amountToNumber(item.refundToTaxPayer);
        tReleaseToApportion += amountToNumber(item.releaseToApportion);
      }
      const totalAmount = amountToNumber(this.totalAmtUnderProtest);

      if (totalAmount === 0) {
        this.custumColrFlashMsg({ msg: 'Selected records have no amount under protest' });
        return;
      }

      const totalResolved = tRefundToTaxPayer + tReleaseToApportion;
      const tPercOfRefund = (tRefundToTaxPayer / totalResolved) * interestAmount;

      const tPercOfRelease = (tReleaseToApportion / totalResolved) * interestAmount;
      this.total.interestRefundAmount = amountToNumber(tPercOfRefund);
      this.total.interestReleaseAmount = amountToNumber(tPercOfRelease);
      this.protestedTax = [...protestTaxes];
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    async applyInterest() {
      if ((this.total.interestRefundAmount === 0 && this.total.interestReleaseAmount === 0)
      || this.total.interestAmount === 0) {
        this.custumColrFlashMsg({ msg: 'Please breakdown interest first before applying' });
        return;
      }

      const protestTaxes = this.selectedItems.filter((el) => typeof el === 'object');
      if (protestTaxes.length === 0) {
        this.custumColrFlashMsg({ msg: 'Please select records to apply interest' });
        return;
      }
      const interestAmount = amountToNumber(this.total.interestAmount);
      const totalAmount = amountToNumber(this.totalAmtUnderProtest);

      if (totalAmount === 0) {
        this.custumColrFlashMsg({ msg: 'Selected records have no amount under protest' });
        return;
      }

      // Store the current selection state (including IDs of selected items)
      const currentSelectedItems = [...this.selectedItems];
      const selectedItemIds = protestTaxes.map((item) => item._id);

      // Calculate totals for proportional distribution
      let totalRefundToTaxPayer = 0;
      let totalReleaseToApportion = 0;

      protestTaxes.forEach((item) => {
        totalRefundToTaxPayer += amountToNumber(item.refundToTaxPayer);
        totalReleaseToApportion += amountToNumber(item.releaseToApportion);
      });

      // Create a copy of selected items to modify
      const updatedProtestTaxes = protestTaxes.map((item) => ({ ...item }));

      for (let i = 0; i < updatedProtestTaxes.length; i += 1) {
        const item = updatedProtestTaxes[i];
        console.info('interestAmount', interestAmount);

        // Distribute interest proportionally based on each item's refund/release amounts
        const percOfRefund = totalRefundToTaxPayer > 0
          ? (amountToNumber(item.refundToTaxPayer) / totalRefundToTaxPayer)
          * this.total.interestRefundAmount
          : 0;
        const percOfRelease = totalReleaseToApportion > 0
          ? (amountToNumber(item.releaseToApportion) / totalReleaseToApportion)
          * this.total.interestReleaseAmount
          : 0;

        item.interestOfRefund = amountToNumber(percOfRefund);
        item.interestOfRelease = amountToNumber(percOfRelease);
        item.totalRefund = amountToNumber(item.refundToTaxPayer)
        + amountToNumber(item.interestOfRefund);
        item.totalRelease = amountToNumber(item.releaseToApportion)
        + amountToNumber(item.interestOfRelease);
        console.info('interestAmount', interestAmount, this.total.interestRefundAmount, this.total.interestReleaseAmount);
        console.info('percOfRefund', percOfRefund);
        console.info('percOfRelease', percOfRelease);
      }

      // this.total.interestRefundAmount = amountFormat(tPercOfRefund);
      // this.total.interestReleaseAmount = amountFormat(tPercOfRelease);

      // Update only the selected items in the main items list
      const allItems = [...this.protestTaxesGetter];
      updatedProtestTaxes.forEach((updatedItem) => {
        const index = allItems.findIndex((item) => item._id === updatedItem._id);
        if (index !== -1) {
          // Remove totalAmt property if it exists
          const itemToUpdate = { ...updatedItem };
          if (itemToUpdate.totalAmt) {
            delete itemToUpdate.totalAmt;
          }
          delete itemToUpdate.taxDue;
          allItems[index] = itemToUpdate;
        }
      });

      // Update the store with all items (including the modified selected ones)
      this.setItems([this.baseCrudKey, allItems]);

      const deletedKeys = [
        'taxrolladjustment',
        'schoolDistrict',
        'taxDue',
        'taxInquiryTransaction',
        'fundAmount',
        'ownerName',
        'sharedFund',
        ' taxDue',
        'totalTax',
        'totalPaid',
        'totalPayment',
        'fundNo',
        'totalAmt',
        'taxDistrict',
        'amountStillDue',
        'totalDue',
        'name1',
        'name2',
      ];
      updatedProtestTaxes.forEach((rec) => {
        deletedKeys.forEach((key) => {
          // eslint-disable-next-line no-param-reassign
          delete rec[key];
        });
      });

      await this.upsertTransaction(updatedProtestTaxes).then(() => {
        // After the transaction is complete, restore the selection state
        // Wait for the next tick to ensure the items are updated in the store
        this.$nextTick(() => {
          // Get the updated items from the store
          const updatedAllItems = this.protestTaxesGetter;

          // Reconstruct the selected items array with updated data but maintaining selection
          const restoredSelectedItems = [];

          // Add back the non-object selected items (like IDs)
          currentSelectedItems.forEach((selectedItem) => {
            if (typeof selectedItem !== 'object') {
              restoredSelectedItems.push(selectedItem);
            }
          });

          // Add back the updated object items that were previously selected
          selectedItemIds.forEach((id) => {
            const updatedItem = updatedAllItems.find((item) => item._id === id);
            if (updatedItem) {
              restoredSelectedItems.push(updatedItem);
            }
          });

          // Restore the selection
          this.setSelectedItems(restoredSelectedItems);
        });
      });
    },
    async handleReport() {
      const items = this.selectedItems.filter((el) => typeof el === 'object');
      const idArr = items.map((el) => el._id);
      if (idArr.length < 1) {
        this.custumColrFlashMsg({ msg: 'Please select a record' });
        return;
      }
      const ids = idArr.join();
      const { jwt } = await this.reAuth();
      const toUrl = `${backendRest.defaults.baseURL}/tax/protest-summary?ids=${ids}&token=${jwt}`;
      window.open(toUrl, '_blank');
    },
    async upsertTransaction(item) {
      const deletedFields = ['ownerName', 'sharedFund', 'taxrolladjustment', 'totalTax', 'totalPaid', 'taxDistrict', 'fundAmount', 'fundNo', 'amountStillDue'];

      const { baseCrudKey } = this;
      const updatedItem = item;
      // eslint-disable-next-line array-callback-return
      updatedItem.forEach((taxItem, i) => {
        // eslint-disable-next-line no-unused-expressions, no-param-reassign
        deletedFields.forEach((key) => {
          // eslint-disable-next-line no-param-reassign

          if (taxItem[key]) {
            // eslint-disable-next-line no-param-reassign
            delete taxItem[key];
            // return taxItem;
          }
        });
        if (updatedItem[i].fund && typeof updatedItem[i].fund === 'object') {
          updatedItem[i].fund = taxItem.fund._id;
        }
        // updatedItem[i].fund = taxItem.fund._id;
        updatedItem[i].taxInquiryTransaction = null;
      });

      await this.upsertBulkTaxProtest({
        item: updatedItem,
        baseCrudKey,
      }).then(() => {
        // this.loadProtestsData();
      });
    },
    loadProtestsData() {
      const { baseCrudKey } = this;
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      const criteria = {
        ...this.criteriaState,
      };
      this.loadTaxProtests({
        criteria,
        baseCrudKey,
        postProcessTrans: this.protestTaxPostProcessTrans,
      });
    },

    protestTaxPostProcessTrans(items) {
      const updatedItems = [];
      for (let i = 0; i < items.length; i += 1) {
        // const item = { ...items[i] };
        // item.sharedFund = amountToNumber(item.totalTax || 0 - item.totalPaid || 0);
        // item.fundNo = (item.fund || {}).fund;
        // // eslint-disable-next-line max-len
        // item.totalAmt = amountToNumber((item.taxInquiryTransaction || {}).totalTax);
        // // eslint-disable-next-line max-len
        // item.totalPaid = amountToNumber((item.taxInquiryTransaction || {}).totalTax) -
        //  amountToNumber((item.taxInquiryTransaction || {}).adjustments);
        // item.refundToTaxPayer = amountToNumber(item.totalPaid) - amountToNumber(item.totalAmt);
        // // eslint-disable-next-line max-len
        // item.releaseToApportion = amountToNumber(item.amountPaidUnderProtest) -
        // amountToNumber(item.refundToTaxPayer);
        // // eslint-disable-next-line no-unused-expressions

        // item.totalRefund = amountToNumber(item.refundToTaxPayer) + (item.interestOfRefund);
        // item.totalRelease = amountToNumber(item.releaseToApportion) + (item.interestOfRelease);
        // item.ownerName = item.taxInquiryTransaction ? `${(item.taxInquiryTransaction || '').name1
        //  || ''} ${(item.taxInquiryTransaction || '').name2 || ''}` : '';
        // item.taxDistrict = (item.taxInquiryTransaction || {}).schoolDistrict;
        // updatedItems.push(item);
        const item = { ...items[i] };
        item.fundNo = (item.fund || {}).fund;
        item.taxDue = amountToNumber((item.taxInquiryTransaction || {}).totalTax || 0);
        item.ownerName = item.taxInquiryTransaction ? `${(item.taxInquiryTransaction || '').name1
         || ''} ${(item.taxInquiryTransaction || '').name2 || ''}` : '';
        item.schoolDistrict = (item.taxInquiryTransaction || {}).schoolDistrict || '';
        item.totalPaid = amountToNumber((item.taxInquiryTransaction || {}).totalPaid || 0);
        item.totalRefund = amountToNumber(item.refundToTaxPayer) + (item.interestOfRefund);
        // eslint-disable-next-line max-len
        item.totalRelease = amountToNumber(item.releaseToApportion) + (item.interestOfRelease);

        // item.sharedFund = amountToNumber(item.totalTax || 0 - item.totalPaid || 0);
        // item.fundNo = item.fundNo || (item.fund || {}).fund;
        // item.totalAmt = amountToNumber((item.taxInquiryTransaction || {}).totalTax);

        // if (!item.amountStillDue) {
        // eslint-disable-next-line max-len
        // item.amountStillDue = amountToNumber(amountToNumber(item.totalAmt) - amountToNumber(item.totalPaid));
        // }
        // eslint-disable-next-line max-len
        // item.amountStillDue = amountToNumber(amountToNumber(item.totalDue) - amountToNumber(item.totalPaid));
        // if (!item.amountPaidNoProtest) {
        //   item.amountPaidNoProtest = amountToNumber(amountToNumber(item.totalPaid)
        // - amountToNumber(item.amountPaidUnderProtest));
        // }

        // item.totalAmt = item.totalAmt
        // || amountToNumber((item.taxInquiryTransaction || {}).totalTax);
        // + amountToNumber((item.taxInquiryTransaction || {}).adjustments);
        // amountToNumber((item.taxInquiryTransaction || {}).totalTax);
        // eslint-disable-next-line max-len
        // item.totalPaid = amountToNumber((item.taxInquiryTransaction || {}).totalTax) - amountToNumber((item.taxInquiryTransaction || {}).adjustments);
        // (item.taxInquiryTransaction || {}).totalPaid;
        // item.refundToTaxPayer = item.refundToTaxPayer
        // || amountToNumber(item.totalPaid) - amountToNumber(item.totalAmt);
        // item.releaseToApportion = item.releaseToApportion
        // || amountToNumber(item.amountPaidUnderProtest) - amountToNumber(item.refundToTaxPayer);

        // eslint-disable-next-line max-len
        // item.totalRefund = item.totalRefund || amountToNumber(item.refundToTaxPayer) + (item.interestOfRefund);
        // eslint-disable-next-line max-len
        // item.totalRelease = item.totalRelease || amountToNumber(item.releaseToApportion) + (item.interestOfRelease);
        // item.ownerName = item.taxInquiryTransaction ? `${(item.taxInquiryTransaction || '').name1
        //  || ''} ${(item.taxInquiryTransaction || '').name2 || ''}` : '';
        updatedItems.push(item);
      }
      return updatedItems;
    },
    async nextRecieptNumber(taxYear) {
      const recNumber = await this.generateMultipleReceipt({ taxYear });
      const results = {};
      for (const item of recNumber) {
        results[item.taxYear] = item.maxReceipt + 1;
      }
      return results;
    },
    async handleMakePayment(paymentType) {
      const result = this.selectedItems.filter((el) => typeof el === 'object');
      if (result.length < 1) {
        this.custumColrFlashMsg({ msg: 'Please select a record' });
        return;
      }

      const taxYearList = [];
      for (const item of result) {
        if (!taxYearList.includes(item.taxYear)) {
          taxYearList.push(item.taxYear);
        }
      }

      const recieptNumbers = await this.nextRecieptNumber(taxYearList);
      this.setItem([this.crudKeyForPayment, this.postprocessData(result, recieptNumbers,
        paymentType)]);
      this.setIndex([this.crudKeyForPayment, -1]);
      this.setIsVisible([this.crudKeyForPayment, true]);
    },

    async createApportRecords() {
      const items = this.selectedItems.filter((el) => typeof el === 'object');
      if (items.length < 1) {
        this.custumColrFlashMsg({ msg: 'Please select a record' });
        return;
      }
      const businessDate = new Date(this.businessDate);
      const year = businessDate.getFullYear();
      const month = businessDate.getMonth();

      // First day of the month - create as ISO string directly
      const fromDate = `${year}-${String(month + 1).padStart(2, '0')}-01`;

      // Last day of the month
      const lastDay = new Date(year, month + 1, 0).getDate();
      const toDate = `${year}-${String(month + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
      const apportRecords = [];
      items.forEach((item) => {
        apportRecords.push({
          taxYear: item.taxYear,
          fromDate,
          toDate,
          businessDate: toIsoDate(this.businessDate),
          schoolDistrict: (item.taxInquiryTransaction || {}).schoolDistrict,
          taxAmt: item.interestOfRelease || 0,
          penaltyAmount: 0,
          totalFees: 0,
          totalAmount: item.interestOfRelease || 0,
          isNormalRecord: true,
          description: 'Protest Interest',
          isManualRecord: true,

        });
      });
      const apportionCrudKey = 'taxesApprotionment';
      const updatedItem = apportRecords;
      await this.upsertTaxApportionmentInBulk(
        { item: updatedItem, baseCrudKey: apportionCrudKey },
      );
      // return response;
    },
    async printApportionmentReport(status) {
      const items = this.selectedItems.filter((el) => typeof el === 'object');
      const idArr = items.map((el) => el._id);
      if (idArr.length < 1) {
        this.custumColrFlashMsg({ msg: 'Please select a record' });
        return;
      }
      const ids = idArr.join();
      const { jwt } = await this.reAuth();
      const apportionmentSuffix = `tax/protest/apportionmentReport?ids=${ids}&apportionmentStatus=${status}&token=${jwt}`;
      const toUrlForApportionment = `${backendRest.defaults.baseURL}/${apportionmentSuffix}`;
      const collSummarySuffix = `tax/protest/collection-summary?ids=${ids}&apportionmentStatus=${status}&token=${jwt}`;
      const toUrlForCollectionSummary = `${backendRest.defaults.baseURL}/${collSummarySuffix}`;
      window.open(toUrlForApportionment, '_blank');
      window.open(toUrlForCollectionSummary, '_blank');
    },
    postprocessData(data, recieptNumbers, paymentType) {
      const taxDetails = [];
      const { penaltyDate, penaltyRate } = this.taxSettingItem;
      const currentDate = toShortDate(this.fromDate);
      const incReciept = { ...recieptNumbers };
      let totalAmt = 0;
      for (const item of data) {
        const taxAmt = item.totalTax;
        const {
          totalDue, taxYear, totalFee, totalPaid,
        } = item;

        const returnedVal = penaltyCalculation(currentDate,
          null,
          penaltyDate,
          taxAmt,
          totalPaid,
          totalFee,
          penaltyRate,
          totalDue,
          taxYear,
          [],
          this.taxSettingItem);
        const reciept = incReciept[item.taxYear] + 1;
        const fee = totalFee || 0;
        const total = fee + item.totalTax + returnedVal.penaltyAmt;
        // eslint-disable-next-line operator-assignment
        incReciept[item.taxYear] = incReciept[item.taxYear] + 1;
        if (paymentType === 'refund') {
          taxDetails.push({
            // _id: item._id,
            taxYear: item.taxYear,
            taxId: item.taxId,
            originalTaxId: item.taxId,
            schoolDistrict: item.schoolDistrict,
            taxAmt: -item.refundToTaxPayer || 0,
            penaltyAmt: returnedVal.penaltyAmt,
            totalDue: 0,
            total: -item.refundToTaxPayer || 0,
            //  0,
            reciept,
            protest: true,
            taxType: 'TAXREFUND',
            itsNewRecord: true,
            isFromOtherSources: true,
            isFromProtest: true,
            ownerName: item.ownerName || '',
          });
        } else if (paymentType === 'protest') {
          taxDetails.push({
            // _id: item._id,
            taxYear: item.taxYear,
            taxId: item.taxId,
            originalTaxId: item.taxId,
            schoolDistrict: item.schoolDistrict,
            taxAmt: item.releaseToApportion,
            penaltyAmt: returnedVal.penaltyAmt,
            totalDue: 0,
            total: amountToNumber(item.releaseToApportion),
            reciept,
            protest: false,
            taxType: 'TAXCREDIT',
            itsNewRecord: true,
            isFromOtherSources: true,
            isFromProtest: true,
            ownerName: item.ownerName || '',
          });
          taxDetails.push({
            // _id: item._id,
            taxYear: item.taxYear,
            taxId: item.taxId,
            originalTaxId: item.taxId,
            schoolDistrict: item.schoolDistrict,
            taxAmt: amountToNumber(-item.releaseToApportion),
            penaltyAmt: returnedVal.penaltyAmt,
            totalDue: 0,
            total: amountToNumber(-item.releaseToApportion),
            // fee,
            reciept,
            protest: true,
            taxType: 'TAXCREDIT',
            itsNewRecord: true,
            isFromOtherSources: true,
            isFromProtest: true,
            ownerName: item.ownerName || '',
          });
        }
        totalAmt += total;
        // eslint-disable-next-line no-plusplus
      }
      const paymentNumber = this.nextPaymentNumber;
      const items = {
        fiscalYear: toFiscalYear(new Date()),
        workstation: this.wkstNumber,
        paymentNumber,
        payDate: toShortDate(this.businessDate),
        taxDetails,
        total: amountFormat(totalAmt),
      };

      return items;
    },

  },
};
</script>

<style scoped>
.label {
  font-size: 0.85rem;
}
</style>
